<div class="container test-container">

	<div class="row justify-content-center">

		<div class="col-12 col-sm-8">

			<div class="container">

				<div class="row tests-results">
					
					<div class="col-4">

						<div class="text-center" style="text-align: left;">
						    <span class="title">{{ 'latency.title' | translate }}</span>
						    <div *ngIf="!ping && !download && !upload">
						    	<div class="spinner"></div>
						    </div>
						    <div *ngIf="ping">
						    	<span class="text">{{ping}}</span>&nbsp;<span class="unit">ms</span>
						    </div>			    
						</div>
						
					</div>

					<div class="col-4">
						
						<div class="text-center">
						    <span class="title">{{ 'download.title' | translate }}</span>
						    <div *ngIf="ping && !download && !upload">
						    	<app-tests-chart
						    	[testsStatus]="downloadHistogramToPlot"
						    	[smoothCorners]="true"
						    	[width]="90"
						    	[height]="40">
						    	</app-tests-chart>
						    </div>
						    <div *ngIf="download">
						    	<span class="text">{{download}}</span>&nbsp;<span class="unit">Mbps</span>
						    </div>
						</div>

					</div>

					<div class="col-4">
						
						<div class="text-center">
						    <span class="title">{{ 'upload.title' | translate }}</span><br>
						    <div *ngIf="ping && download && !upload">
						    	<app-tests-chart
						    	[testsStatus]="uploadHistogramToPlot"
						    	[smoothCorners]="true"
						    	[width]="90"
						    	[height]="40">
						    	</app-tests-chart>
						    </div>
						    <div *ngIf="upload">
						    	<span class="text">{{upload}}</span>&nbsp;<span class="unit">Mbps</span>
						    </div>
						</div>

					</div>

				</div>

			</div>
			
		</div>

	</div>

	<div class="row">

		<div class="col-md-3">
		</div>
		
		<div class="col-12 col-md-6">

			<div class="tests">

				<div class="progress-wrapper">

				    <div class="wrapper-inner">
			    		<div class="message">{{testType}}</div>
			       		<div class="tests-speed">{{speedString}}</div>
			       		<div class="tests-unit">{{unit}}</div>
				    </div>

				    <round-progress
				        [current]="progress"
				        [max]="max"
				        [color]="'#3A9AF9'"
				        [background]="'#f1f2f7'"
				        [radius]="150"
				        [duration]="200"
				        [stroke]="10"
				        [semicircle]="false"
				        [rounded]="false"
				        [clockwise]="true"
				        [responsive]="false"
				        [animation]="'easeInOutQuart'"
				        [animationDelay]="0">
				    </round-progress>

				  </div>

			</div>
				
		</div>

		<div class="col-md-3">
		</div>

	</div>

</div>
<footerapp></footerapp>